import { connect } from 'react-redux'

const mapStateToProps = ({ forms: { waiverForms } }) => ({
  waiverForms
})

const actions = {}

const withRedux = connect(mapStateToProps, actions)

export default withRedux
